import React from 'react';
import { useSelector } from 'react-redux';
import { GetFlag } from '../../utils/featureFlag';
import useIsCommerceUser from '../../hooks/useIsCommerceUser';
import useModalPriority, {
  ModalPriorities
} from '../../hooks/useModalPriority';
import { LongSteelOrders3HomepageModal } from '../../pages/Orders/LongSteelOrders3/LongSteelOrders3HomepageModal';
import { FabricationNewJourneyModal } from '../FabricationNewJourneyModal';
import { PurchaseLongoSteelMvpModal } from '../LongSteelMvpModal';
import { ApplicationState } from '../../store';

const AppModals: React.FC = () => {
  const userState = useSelector((state: ApplicationState) => state.user);

  const isFabricationView =
    (userState.roles.fabricationViewCustomers || []).length > 0;
  const isPurchaseMvp = useIsCommerceUser();
  const hasAccessToOrdersPage = userState.userPermissions.hasOrderViewAccess;

  const [showFabricationNewJourney, modalFabricationNewJourneyActions] =
    useModalPriority(
      'modalFabricationNewJourney',
      ModalPriorities.FabricationNewJourney,
      isFabricationView,
      'new_jorney_fabrication',
      true
    );

  const [showPurchaseLongSteelJourney, modalPurchaseLongSteelJourneyActions] =
    useModalPriority(
      'modalNewJourney',
      ModalPriorities.NewJourney,
      isPurchaseMvp,
      'purchase_longsteelmvp_modal',
      true
    );

  const [showNewLongSteelOrdersModal, modalNewLongSteelOrdersActions] =
    useModalPriority(
      'modalNewLongSteelOrders',
      ModalPriorities.NewLongSteelOrders,
      hasAccessToOrdersPage,
      'new_longsteelorders',
      true
    );

  return (
    <>
      {showNewLongSteelOrdersModal && (
        <LongSteelOrders3HomepageModal
          onCloseModal={modalNewLongSteelOrdersActions.close}
          dontShowThisAgain={modalNewLongSteelOrdersActions.dontShowThisAgain}
        />
      )}
      {showFabricationNewJourney && (
        <FabricationNewJourneyModal
          onCloseModal={modalFabricationNewJourneyActions.close}
          dontShowThisAgain={
            modalFabricationNewJourneyActions.dontShowThisAgain
          }
        />
      )}
      {showPurchaseLongSteelJourney && (
        <PurchaseLongoSteelMvpModal
          onCloseModal={modalPurchaseLongSteelJourneyActions.close}
          dontShowThisAgain={
            modalPurchaseLongSteelJourneyActions.dontShowThisAgain
          }
        />
      )}
    </>
  );
};

export default AppModals;
